import * as React from 'react';
import { Grid, GridColumn, ITagProps, Tag } from 'telia-front-react';

export interface FreeTrialMotivatorsItemProps {
  children: React.ReactNode;
  tag: ITagProps;
}

const FreeTrialMotivatorsItem = (props: FreeTrialMotivatorsItemProps): JSX.Element => {
  const { tag, children } = props;

  return (
    <GridColumn width={['xs-12', 'sm-6', 'md-5']}>
      <Grid noWrap={true} align={['middle-xs']}>
        <GridColumn width={['min']}>
          <Tag {...tag} />
        </GridColumn>
        <GridColumn width={['max']}>{children}</GridColumn>
      </Grid>
    </GridColumn>
  );
};

export default FreeTrialMotivatorsItem;
